import React, { Suspense } from 'react'
import { inject, observer } from 'mobx-react'
import Nav from 'react-bootstrap/Nav'
import { NavLink } from 'react-router-dom'
import styled, { keyframes } from 'styled-components'
import { withTranslation } from 'react-i18next'
import { Subheader } from '../components/Page/logix2020/Subheader'

const NewPasswordBox = React.lazy(() =>
  import('../components/PersonalSpaceBox/NewPasswordBox')
)
const PersonalOptionsBox = React.lazy(() =>
  import('../components/PersonalSpaceBox/PersonalOptionsBox')
)

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
`

const PageBackground = styled.div`
  background: #f3f4f6;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  // margin-top: 5px;
  min-height: calc(100vh - 110px);
`

const CenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 20px 56px;
  flex-grow: 1;
`

const ContentStack = styled.div`
  width: 100%;
  max-width: 660px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const Card = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 14px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  animation: ${fadeUp} 0.28s ease both;
  animation-delay: ${({ delay }) => delay || '0s'};
`

export const CardHead = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 24px 16px;
  border-bottom: 1px solid #f3f4f6;
  background: #f9fafb;
`

export const CardHeadIcon = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #ebf2ff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 18px;
    height: 18px;
    stroke: #1a56db;
    fill: none;
    stroke-width: 1.8px;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
`

export const CardHeadText = styled.div`
  display: flex;
  flex-direction: column;
`

export const CardTitle = styled.span`
  font-size: 14.5px;
  font-weight: 600;
  color: #111827;
  line-height: 1.3;
`

export const CardSubtitle = styled.span`
  font-size: 12px;
  color: #9ca3af;
  margin-top: 2px;
`

export const CardBody = styled.div`
  padding: 24px;
`

export const CardFoot = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #f3f4f6;
  background: #f9fafb;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
`

const BackNavWrap = styled.div`
  text-align: center;
  animation: ${fadeUp} 0.28s ease 0.18s both;

  a {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 13px;
    color: #1a56db;
    text-decoration: none;
    padding: 7px 14px;
    border-radius: 6px;
    transition: background 0.15s;

    &:hover {
      background: #ebf2ff;
    }

    svg {
      width: 14px;
      height: 14px;
      stroke: currentColor;
      fill: none;
      stroke-width: 2.2px;
    }
  }
`

const FallbackText = styled.p`
  color: #9ca3af;
  font-size: 13px;
  padding: 24px;
  text-align: center;
`

const PersonalSpace = observer(({ t, profileStore }) => {
  const profile = profileStore.profile

  return (
    <>
      <Subheader className='subHeader-v1'>
        <div>
          <div className='subheader-title'>
            {t('personalSpace:PersonalOptions')}
          </div>
          <div className='subheader-title-small'>
            {profile.businessPartnerDisplayName}
          </div>
        </div>
      </Subheader>

      <PageBackground>
        <CenterWrapper>
          <ContentStack>
            <Suspense
              fallback={
                <FallbackText>
                  Bearbeitungsfunktionen werden geladen…
                </FallbackText>
              }
            >
              <PersonalOptionsBox />
              <NewPasswordBox withCancelButton />
            </Suspense>

            <BackNavWrap>
              <Nav.Link as={NavLink} to='/'>
                <svg viewBox='0 0 24 24'>
                  <polyline points='15 18 9 12 15 6' />
                </svg>
                {t('backToStartpage')}
              </Nav.Link>
            </BackNavWrap>
          </ContentStack>
        </CenterWrapper>
      </PageBackground>
    </>
  )
})

export default withTranslation()(inject('profileStore')(PersonalSpace))
